import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { API_URL } from "../constants/urls";
import { resetAuth } from "../reducers/authSlice";
import { RootState } from "../app/store";
import { STORAGE_KEYS } from "../constants";
import { getFromStorage, setToStorage } from "../helpers";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState).auth;
    const { tempToken } = (getState() as RootState).auth;
    const authTokenFromStorage = getFromStorage(STORAGE_KEYS.token);
    const deviceToken = localStorage.getItem(STORAGE_KEYS.fcmToken);
    console.log(deviceToken, authTokenFromStorage, "authTokenFromStorage");

    // const encryptData = generateSEKAndHash(token || tempToken || null);
    const tokenAuth = token || tempToken || authTokenFromStorage || null;
    console.log(token, "tokentokentoken");
    headers.set("Accept-Language", "en");
    headers.set("x-portal", "admin");
    headers.set("x-device-type", "WEB");
    // headers.set("x-device-token", deviceToken ?? "1234");
    headers.set("Device", "WEB");

    if (tokenAuth) {
      // headers.set('sek', encryptData?.sek);
      headers.set("Authorization", tokenAuth);
      headers.set("appkey", new Date().toISOString());
      // headers.set("authorization",`Bearer ${token}`)l
      // Required headers for the API
    }

    return headers;
  },

  // prepareHeaders: (headers, { getState }) => {
  //   const { token } = (getState() as RootState).auth;
  //   const { tempToken } = (getState() as RootState).auth;
  //   console.log(token,"tokennnnnnnnn");

  //   if (token) {
  //     headers.set("authorization", `Bearer ${token}`);
  //   } else if (tempToken) {
  //     headers.set("authorization", `Bearer ${tempToken}`);
  //   }
  //   headers.set("Device","WEB");
  //   // headers.set("Hash", `${encryptedData?.hash}`);
  //   // headers.set("Sek", ` ${encryptedData?.sek}`);
  // // headers.set("Device","WEB");
  //   return headers;
  // },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  // if (args.body) {
  //   const encryptedData = generateEncryptedKeyBody(args.body);
  //   if (encryptedData) {
  //     args.body = encryptedData;
  //   } else {
  //     return {
  //       error: {
  //         status: 400,
  //         data: { detail: 'Failed to encrypt request body' },
  //       },
  //     };
  //   }
  // }
  const result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    console.log({ errors });
    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }
    if (errors?.length) {
      const error = errors[0] as any;
      if (error?.length) {
        console.log(error[0]);
      }
    }
  }

  if (result?.error?.status === 401) {
    // Persist current path for post-login redirect
    if (typeof window !== "undefined") {
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      try {
        setToStorage(STORAGE_KEYS.redirectPath, current);
      } catch (e) {
        // ignore storage errors
      }
    }
    api.dispatch(resetAuth());
    if (typeof window !== "undefined") {
      window.location.replace("/");
    }
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UNAUTHORIZED", "UNKNOWN_ERROR"],
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
});

export default emptySplitApi;
